export const themes = ["default", "test", "ocean", "dark"];
export const themelessRoutes = ["/", "/login"];
export const darkThemes = ["dark"];
